import React, { useState } from "react";
import { ApiService } from "../../Axios/ApiService";

export const FileUploadContext = React.createContext();

const FileUploadProvider = props => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(false);
    const [croppedFile, setCroppedFile] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [extraOption, setExtraOption] = useState(false);

    const onUploadFiles = async (acceptedFiles, rejectedFiles, scale) => {
        if (acceptedFiles.length === 0){
            setError([{id: 0, message: "Je kunt maar 1 bestand uploaden bij dit product."}]);
        } else {
            try {
                const res = await uploadFiles(acceptedFiles, scale);
                setUploading(false);
                const data = res.data.data;
                setFiles([...files, ...data]);
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors && e.response.data.errors.length > 0){
                    setError(e.response.data.errors)
                } else {
                    setError([{id: 0, message: "Uploading failed"}]);
                    throw e
                }
            }
        }

    };

    const onUploadCroppedFile = async (croppedImageUrl, name) => {
        // Internet Explorer 6-11
        const isIE = /*@cc_on!@*/ false || !!document.documentMode;

        try {
            if (isIE) {
                let file = await fetch(croppedImageUrl)
                    .then(r => r.blob())
                    .then(
                        blob => {
                            blob.lastModifiedDate = new Date();
                            return blob
                        }
                    );
                    const res = await uploadCroppedFile(file);
                    const newFile = res.data.data;
                    setUploading(false);
                    setCroppedFile(newFile);
            } else {
                let file = await fetch(croppedImageUrl)
                    .then(r => r.blob())
                    .then(
                        blobFile =>
                            new File([blobFile], name + "_cropped.jpeg", {
                                type: "image/jpeg"
                            })
                    );
                const res = await uploadCroppedFile(file);
                const newFile = res.data.data;
                setUploading(false);
                setCroppedFile(newFile);
            }
        } catch (e) {
            if(e.response.data && e.response.data.errors && e.response.data.errors.length > 0){
                setError(e.response.data.errors)
            }
            setError([{id: 0, message: "Uploading failed"}]);
            throw e;
        }
    };

    const onDeleteFile = fileValue => {
        const newFiles = files.filter(file => file.value !== fileValue);
        setFiles(newFiles);
    };

    const uploadFiles = (files, scale) => {
        const formData = new FormData();
        formData.append("scale", scale);
        files.forEach(file => {
            formData.append("uploadFile[]", file);
        });

        return ApiService.post("/file/upload", formData, config);
    };

    const uploadCroppedFile = async file => {
        const formData = new FormData();
        formData.append("uploadFile[]", file);
        formData.append("thumb", true);
        return ApiService.post("/file/upload", formData, config);
    };

    const onDeleteCropped = () => {
        setCroppedFile(false);
    };

    const onShowUploadModal = () => {
        setShowModal(true);
        setError(false);
        setUploading(false);
    };
    const onHideUploadModal = () => {
        setShowModal(false);
        setError(false);
        setUploading(false);
    };

    const config = {
        onUploadProgress: progressEvent =>
            setUploading((progressEvent.loaded / progressEvent.total) * 100)
    };

    const onSelectExtraOption = val => {
        if (val === extraOption) {
            setExtraOption(false);
        } else {
            setExtraOption(val);
        }
    };

    const value = {
        showModal,
        onShowUploadModal,
        onHideUploadModal,
        files,
        uploading,
        setUploading,
        error,
        setError,
        onUploadFiles,
        onUploadCroppedFile,
        croppedFile,
        onDeleteFile,
        uploadCroppedFile,
        onDeleteCropped,
        onSelectExtraOption,
        extraOption,
        uploadSetting: props.uploadSetting ? props.uploadSetting : "1"
    };

    return (
        <FileUploadContext.Provider value={value}>
            {props.children}
        </FileUploadContext.Provider>
    );
};

export default FileUploadProvider;

export const EXTENDED_CONTROL = "extended_control";
export const DESIGN_FILE = "design_file";
export const PRICES = {
    [EXTENDED_CONTROL]: 17.50,
    [DESIGN_FILE]: 17.50
};
